<template>
  <section
    :style="{
      height: '100vh',
    }"
  >
    <div class="grid grid-nogutter h-full md:flex-row bg-white">
      <div class="col-12 md:col-5">
        <div
          class="pod-image"
          :style="{
            backgroundImage: `url(${rectLogo})`,
          }"
        >
        </div>
      </div>
      <div class="col-12 md:col-7 bg-white">
        <div class="flex justify-content-center md:pt-8 px-3">
          <div class="password-reset-form-container">
            <VeeForm
              v-slot="{ handleSubmit }"
              :validation-schema="schema"
              as="div"
              @invalidSubmit="onInvalidSubmit"
            >
              <form @submit.prevent="handleSubmit($event, onSubmit)">
                <h1 class="text-center text-4xl">Forgot Password</h1>
                <p class="mb-5">
                  Enter your email. If you have an account, we will send you an email
                  to complete the password reset.
                </p>

                <BaseInput
                  v-model="form.email"
                  fieldId="email"
                  fieldName="email"
                  fieldLabel="Email"
                />
                <Button
                  class="justify-content-center w-full"
                  type="submit"
                  :loading="isSubmitting"
                  label="Submit"
                />
              </form>
            </VeeForm>
            <p
              class="block text-center"
            >
               Return to
              <router-link :to="{ name: ROUTE_LOGIN }">Login</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { object, string } from 'yup';
import rectLogo from '@/assets/ekoz_rect.jpeg';
import { ROUTE_LOGIN } from '@/router/routes';
import { parseMessageFromError } from '@/utils/errors';
import { INVALID_FORM_SUBMISSION_MESSAGE } from '@/utils/messages';
import * as api from '@/api';

export default {
  data() {
    return {
      ROUTE_LOGIN,
      rectLogo,
      isSubmitting: false,
      form: {
        email: '',
      },
      schema: object({
        email: string().email().required('Email is required'),
      }),
    };
  },
  methods: {
    onInvalidSubmit() {
      this.$toast.add({
        severity: 'warn',
        detail: INVALID_FORM_SUBMISSION_MESSAGE,
      });
    },
    async onSubmit({ email }, { resetForm }) {
      try {
        this.isSubmitting = true;

        await api.requestPasswordReset({
          email,
        });

        this.$toast.add({
          severity: 'success',
          detail: 'If your account exists, we have sent a password reset link.',
        });

        resetForm();
      } catch (error) {
        const message = parseMessageFromError(error, 'Invalid email or password');

        this.$toast.add({
          severity: 'error',
          detail: message,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password-reset-form-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 400px;
}
.pod-image {
  height: 140px;
  width: 100%;
  background-size: cover;
  background-position: center 25%;

  @media (min-width: 768px) {
    height: 100%;
    background-position: center;
  }
}
</style>
